firebird.factory('customerSupportService', [
    '$rootScope',
    'attendeeService',
    'meetingService',
    '$window',
    '$http',
    'logService',
    'brandingService',
    'meetingAPIService',
    function (
        $rootScope,
        attendeeService,
        meetingService,
        $window,
        $http,
        logService,
        brandingService,
        meetingAPIService
    ) {
        const logger = logService.createLoggerWithSource('customerSupportService');
        const agentsCheckTimeInterval = 120000; // 2 minutes (2 * 60 * 1000)

        let snapEngageCodeHasBeenAdded = false;
        let agentStatusCheckingInterval;
        let odaAgentStatusCheckingInterval;

        // SnapEngage widget ids
        let anyMeetingWidgetId = '90d80640-606c-4fd8-bbc9-edb5e03226a7';
        let interMediaDirectWidgetId = '12a34424-3995-4935-a82a-5292d4981e9a';
        let interMediaPLRWebinarWidgetId = '65f5e8be-7ab9-4977-bf6f-1719adcdf0c2';

        let liveChatConfig;

        const service = {
            enableSnapEngageLiveSupportWidget: enableSnapEngageLiveSupportWidget,
            disableSnapEngageLiveSupportWidget: disableSnapEngageLiveSupportWidget,
            hideButton: hideButton,
            openCustomerSupport: openCustomerSupport,
            canLoadSnapEngage: canLoadSnapEngage,
            initODAChatWidget: initODAChatWidget,
            canUseODACustomerService: canUseODACustomerService,
            getODAAgentQueueStats: getODAAgentQueueStats,
            ODACleanUp: ODACleanUp
        };

        $rootScope.$on('disable-snap-engage-live-support', service.disableSnapEngageLiveSupportWidget);

        return service;

        ////////////////////////

        function loadSnapEngageLiveSupportWidget() {
            if (snapEngageCodeHasBeenAdded === true) {
                logger.log(
                    'loadSnapEngageLiveSupportWidget',
                    'customerSupportService##loadSnapEngageLiveSupportWidget#startAgentStatusChecking'
                );
                startAgentStatusChecking();
            } else {
                if (canLoadSnapEngage()) {
                    logger.log(
                        'loadSnapEngageLiveSupportWidget',
                        'customerSupportService##loadSnapEngageLiveSupportWidget#Adding Live Support Chat Widget...'
                    );

                    // Mark that we are adding the SnapEngage widget code
                    snapEngageCodeHasBeenAdded = true;

                    // begin SnapEngage code
                    (function () {
                        let se = document.createElement('script');
                        se.type = 'text/javascript';
                        se.async = true;
                        se.src = getSnapEngageJSPath();

                        let done = false;
                        let seInit = false;
                        se.onload = se.onreadystatechange = function () {
                            if (
                                !done &&
                                (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')
                            ) {
                                done = true;
                                /* Place your SnapEngage JS API code below */
                                /* SnapEngage.allowChatSound(true); Example JS API: Enable sounds for Visitors. */

                                hideButton();

                                startAgentStatusChecking();

                                $window.SnapEngage.setUserEmail(attendeeService.getEmail());

                                $window.SnapEngage.setCallback('ChatMessageReceived', function (agent, msg) {
                                    if (seInit == false) {
                                        if (attendeeService.getIsHost() === true) {
                                            $window.SnapEngage.sendTextToChat('Account Owner');
                                        }
                                        seInit = true;
                                    }
                                });
                            }
                        };
                        let s = document.getElementsByTagName('script')[0];
                        s.parentNode.insertBefore(se, s);
                    })();
                    // end SnapEngage code
                }
            }
        }

        function getSnapEngageJSPath() {
            let widgetId;
            if (meetingService.isIntermediaDirectUser()) {
                widgetId = interMediaDirectWidgetId;
            } else if (meetingService.isWebinar() && meetingService.isIntermediaPLRUser()) {
                widgetId = interMediaPLRWebinarWidgetId;
            } else {
                widgetId = anyMeetingWidgetId;
            }

            return '//storage.googleapis.com/code.snapengage.com/js/' + widgetId + '.js';
        }

        function hideButton() {
            if (
                $window.SnapEngage !== undefined &&
                $window.SnapEngage.hideButton !== undefined &&
                $window.SnapEngage.setCallback !== undefined
            ) {
                $window.SnapEngage.hideButton();
                $window.SnapEngage.setCallback('Close', function (type, status) {
                    $window.SnapEngage.hideButton();
                });
            }
        }

        function enableSnapEngageLiveSupportWidget() {
            loadSnapEngageLiveSupportWidget();
        }

        function disableSnapEngageLiveSupportWidget() {
            logger.log(
                'disableSnapEngageLiveSupportWidget',
                'customerSupportService##disableSnapEngageLiveSupportWidget'
            );
            stopAgentStatusChecking();
            $rootScope.$broadcast('snapengage-agent-status', false);
        }

        // Check the widget status every 2 minutes
        function checkAgentStatus() {
            if (canUseSnapEngage()) {
                $window.SnapEngage.getAgentStatusAsync(function (online) {
                    logger.log('checkAgentStatus', 'customerSupportService## ONLINE: ', online);
                    $rootScope.$broadcast('snapengage-agent-status', online);
                });
            }
        }

        function startAgentStatusChecking() {
            // Stop the interval if it is already running
            stopAgentStatusChecking();

            // Check the agent status right away
            checkAgentStatus();

            // Check again every 2 minutes
            agentStatusCheckingInterval = setInterval(checkAgentStatus, agentsCheckTimeInterval);
        }

        function stopAgentStatusChecking() {
            if (agentStatusCheckingInterval) {
                clearInterval(agentStatusCheckingInterval);
                agentStatusCheckingInterval = null;
            }
        }

        function openCustomerSupport() {
            logger.log('openCustomerSupport', 'customerSupportService#openCustomerSupport called');
            if (canUseSnapEngage()) {
                $window.SnapEngage.startPreChat();
            }
        }

        function canUseSnapEngage() {
            logger.log(
                'canUseSnapEngage',
                'customerSupportService#canUseSnapEngage - $window.SnapEngage is undefined: ',
                $window.SnapEngage === undefined
            );
            return $window.SnapEngage !== undefined && canLoadSnapEngage();
        }

        function canLoadSnapEngage() {
            const isPresenter = attendeeService.getIsPresenter();
            const featureList = meetingService.getFeatureList();
            const customerSupportEnabled = featureList.phoneCustomerSupport === 'enabled';

            return brandingService.isSnapEngageWidgetVisible() && isPresenter && customerSupportEnabled;
        }

        function initODAChatWidget() {
            if (!canUseODACustomerService()) {
                return;
            }

            const userFullName = attendeeService.getScreenName().split(' ');
            const userInfo = {
                firstName: userFullName[0],
                lastName: userFullName[userFullName.length - 1] || '',
                email: attendeeService.getEmail()
            };

            meetingAPIService
                .getLiveChatConfigs()
                .then(config => {
                    logger.log('initODAChatWidget', 'got live chat configs', config);
                    liveChatConfig = config;
                    initODASDK('Bots', config, userInfo);
                    startOdaAgentStatusCheking();
                })
                .catch(error => {
                    logger.error('initODAChatWidget', 'failed to get oracle live chat configs', error);
                });
        }

        function canUseODACustomerService() {
            const isPresenter = attendeeService.getIsPresenter();
            const featureList = meetingService.getFeatureList();
            const customerSupportEnabled = featureList.phoneCustomerSupport === 'enabled';

            return isPresenter && customerSupportEnabled && meetingService.isIntermediaDirectUser();
        }

        function startOdaAgentStatusCheking() {
            stopOdaAgentStatusChecking();
            checkOdaAgentStatus();
            odaAgentStatusCheckingInterval = setInterval(checkOdaAgentStatus, agentsCheckTimeInterval);
        }

        function stopOdaAgentStatusChecking() {
            if (odaAgentStatusCheckingInterval) {
                clearInterval(odaAgentStatusCheckingInterval);
                odaAgentStatusCheckingInterval = null;
            }
        }

        function checkOdaAgentStatus() {
            getODAAgentQueueStats()
                .then(response => {
                    logger.log('getODAAgentQueueStats', 'queue checked', response.data.totalAvailableAgents);
                    $rootScope.$broadcast('oda-live-chat-total-available-agents', response.data.totalAvailableAgents);
                })
                .catch(response => {
                    stopOdaAgentStatusChecking();
                    logger.warn('getODAAgentQueueStats', 'failed to check agents status: ', response);
                });
        }

        function getODAAgentQueueStats() {
            return $http({
                method: 'POST',
                url: liveChatConfig.queueStatsUrl,
                data: {
                    queueId: liveChatConfig.queueId,
                    chatProactiveAvailableType: 'AGENTS'
                },
                headers: {
                    'Content-Type': 'application/json',
                    'OSvC-CREST-Application-Context': 'getQueueStats AnyMeeting'
                }
            });
        }

        function ODACleanUp() {
            stopOdaAgentStatusChecking();

            try {
                if ($window.Bots) {
                    $window.Bots.destroy();
                }
            } catch (error) {
                logger.error('ODACleanUp', 'Bots.destroy failed', error);
            }
        }
    }
]);
